import { useSuspenseQuery } from '@tanstack/react-query'

import { workerInfoQueryOptions } from '@/queries/auth'
import { useOrg } from '@/selectors/organization'
import { useOrganizationStore } from '@/store/organization/organization'

export const useOnboardingUrl = (): string => {
  const orgUuid = useOrganizationStore(state => state.orgId)
  const {
    data: { usesUnifiedOnboarding, orgInfo },
  } = useOrg()
  const { data: workerOrganizations } = useSuspenseQuery(workerInfoQueryOptions)
  const { employee_id } =
    workerOrganizations.find(org => org.org_uuid === orgUuid) || {}

  if (!orgUuid || !orgInfo) {
    // Fallback to generic onboarding URL if org data is missing
    return import.meta.env.VITE_ONBOARDING_URL
  } else if (usesUnifiedOnboarding && employee_id) {
    // Proceed to unified onboarding flow if enabled
    return `${import.meta.env.VITE_UNIFIED_ONBOARDING_URL}?org_id=${orgUuid}&worker_id=${employee_id}`
  } else {
    // Default to legacy onboarding flow
    return `${import.meta.env.VITE_ONBOARDING_URL}?org=${orgInfo.id}`
  }
}
